import { core } from '../core/index.js';

export type FabricWebviewHideNavbarApi = () => void;

/**
 * 隐藏导航栏
 */
export const hideNavbar: FabricWebviewHideNavbarApi = () => {
  core.call<'fabric_webview.hideNavbar', {}>('fabric_webview.hideNavbar');
};
